import React from 'react';
export const MuroDepContext = React.createContext({});
MuroDepContext.displayName = 'MuroDepContext';

//# sourceMappingURL=MuroDepContext.js.map